import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../layout/front'),
        redirect: '/multitrade/acceuil',
        children: [
            {
                path: '/multitrade/acceuil',
                name: 'Acceuil',
                component: () => import('../views/front')
            },
            {
                path: '/multitrade/fonctionnalités',
                name: 'Fonctionnalités',
                component: () => import('../views/front/fonctionnality')
            },
            {
                path: '/multitrade/services',
                name: 'A propos',
                component: () => import('../views/front/propos'),
            },
            {
                path: '/multitrade/vos-idees',
                name: 'Vos idées',
                component: () => import('../views/front/ide'),
            },
            {
                path: '/multitrade/capture',
                name: 'Capture',
                component: () => import('../views/front/capture'),
            },
            {
                path: '/multitrade/references',
                name: 'Reference',
                component: () => import('../views/front/references'),
            },
            {
                path: '/multitrade/contact',
                name: 'Contact',
                component: () => import('../views/front/contact')
            },
        ]
    },
    { path: '*', redirect: '/404', hidden: true }
]

let router = new Router({
    mode: 'history',
    routes: constantRoutes
})

export default router
